import React from 'react';
import { useTranslation } from 'react-i18next';

import { Field, FieldArray, useFormikContext } from 'formik';
import { StyledGoalItemListItem } from 'modules/Report/layout/Goals/GoalItem/styled';

import AddToDoItem from '../AddTodo';
import GoalItemFormCheckBox from './FormCheckBox';
import { StyledStepFormToDoList } from './styled';

interface PropsType {
	goalIndex: number;
	onDelete?: (id: number) => void;
	type?: 'error' | 'warning' | 'info' | 'success';
}

function StepFormToDoList({ type = 'info', goalIndex, onDelete }: PropsType) {
	const { t } = useTranslation();
	const { values } = useFormikContext<any>();
	const goal: any = values.goals[goalIndex];

	return (
		<StyledStepFormToDoList>
			<FieldArray
				name={`goals.${goalIndex}.steps`}
				render={({ push, remove }) => (
					<>
						{goal?.steps?.map((item: any, index: number) => (
							// @ts-ignore
							<StyledGoalItemListItem key={index} type={type}>
								<Field name={`goals.${goalIndex}.steps.${index}.is_done`}>
									{({ field }: any) => (
										<GoalItemFormCheckBox
											label={item.title}
											name={`goals.${goalIndex}.steps.${index}.is_done`}
											checked={!!field.value}
											disabled
											onRemove={() => {
												goal?.steps[index]?.id && onDelete(goal?.steps[index]?.id);
												remove(index);
											}}
										/>
									)}
								</Field>
							</StyledGoalItemListItem>
						))}
						<AddToDoItem
							label={t('report.goals.describeSubGoal')}
							onSave={(title) => push({ title, is_done: false })}
						/>
					</>
				)}
			/>
		</StyledStepFormToDoList>
	);
}

export default StepFormToDoList;
